import { render, staticRenderFns } from "./CCBtn.vue?vue&type=template&id=296e93e0&scoped=true&"
import script from "./CCBtn.vue?vue&type=script&lang=ts&"
export * from "./CCBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CCBtn.vue?vue&type=style&index=0&id=296e93e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e93e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
